import { createReduxActionTypes } from '../../../utils/actionFactory';

const OPEN_SPLIT_RANGE = 'OPEN_SPLIT_RANGE';
const RESET_SPLIT_RANGE = 'RESET_SPLIT_RANGE';

export const actionTypes = createReduxActionTypes('SPLIT_RANGE', [
  OPEN_SPLIT_RANGE,
  RESET_SPLIT_RANGE
]);

const DEFAULT_STATE = {
  open: false,
  ranges: []
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_SPLIT_RANGE]: {
      const { ranges, resetValues, isBeTable } = action;
      return {
        ...state,
        open: true,
        ranges,
        resetValues,
        isBeTable
      };
    }
    case actionTypes[RESET_SPLIT_RANGE]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openSplitRange: ({ ranges, resetValues, isBeTable }) => ({
    type: actionTypes[OPEN_SPLIT_RANGE],
    ranges,
    resetValues,
    isBeTable
  }),
  closeSplitRange: () => ({ type: actionTypes[RESET_SPLIT_RANGE] })
};
